import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPersianModule } from 'ngx-persian';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { GuidePagesComponent } from './components/guide-pages/guide-pages.component';
import { HomeComponent } from './components/home/home.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginComponent } from './components/login/login.component';
import { CustomMapComponent } from './components/map/custom-map.component';
import { PaymentComponent } from './components/payment/payment.component';
import { SpecialistChangePasswordComponent } from './components/specialist-change-password/specialist-change-password.component';
import { SpecialistLoginComponent } from './components/specialist-login/specialist-login.component';
import { SpecialistMyRegistrationComponent } from './components/specialist-my-registration/specialist-my-registration.component';
import { SpecialistRegistrationComponent } from './components/specialist-registration/specialist-registration.component';
import { SpecialistVerificationComponent } from './components/specialist-verification/specialist-verification.component';
import { WorkProfileComponent } from './components/work-profile/work-profile.component';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { FilterPipe, PhoneNumberValidationDirective } from './shared/pipes/filter.pipe';
import { FileUploaderComponent } from './shared/file-uploader/file-uploader.component';
import { NumericOnlyDirective } from './directives/numeric-only.directive';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    WorkProfileComponent,
    HomeComponent,
    GuidePagesComponent,
    FooterComponent,
    LoginComponent,
    CustomMapComponent,
    PaymentComponent,
    SpecialistLoginComponent,
    SpecialistChangePasswordComponent,
    SpecialistVerificationComponent,
    SpecialistRegistrationComponent,
    PhoneNumberValidationDirective,
    SpecialistMyRegistrationComponent,
    FilterPipe,
    FileUploaderComponent,
    NumericOnlyDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxPersianModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      easing: 'slide-in',
      timeOut: 3000,
      preventDuplicates: true,
    }),
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSnackBarModule,
    NgbModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      // enabled: environment.production,
      enabled: false,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})

export class AppModule { }